import { useContext } from 'react';
import { InternalNavigationLink, Page } from '../../components';
import { termsOfUseRoutes } from '../../config/router';
import { DxfIntegrationContext } from '../../context/dxfIntegrationContext';
import { PlatformContext } from '../../context/platformContext';
import { interpolateContentToJSX } from '../../helpers';
import { useContent } from '../../hooks/use-content';

export const TermsOfUseForSubusersPage = () => {
  const content = useContent();
  const platformContext = useContext(PlatformContext);
  const dxfIntegrationContext = useContext(DxfIntegrationContext);

  const contentKeyPage: string = content.t('portal.termsOfUse.subUsers');

  const jsxContent: JSX.Element[] = interpolateContentToJSX(contentKeyPage, [
    {
      selector: 'default-link-subusers',
      element: InternalNavigationLink,
      elementProps: {
        href: dxfIntegrationContext.getInternalNavigationLink('subusers'),
        text: content.t('portal.termsOfUse.linkText'),
      },
    },
  ]);

  return (
    <Page
      links={termsOfUseRoutes(content, { isDPASupported: dxfIntegrationContext.isDPASupported, isDXF: platformContext.isDXF })}
      enforcedTabId='200'
    >
      {...jsxContent}
    </Page>
  );
};
